<template>
    <div class="pt-2">
      <v-btn color="white" style="color: black;" block v-if="selectMode==false" :disabled="!header_is_saved" @click="initializeSelectMode" >{{header_is_saved ? '+ Add Cost Type' : 'Save Primary Data Before Adding'}}</v-btn>
      <div v-else class="d-flex">
        <v-combobox  outlined v-model="selectedCostType" :items="optionsList"  label="Select Cost Type...">
        </v-combobox>
        <v-text-field 
        outlined
            class="ml-2"
            label="Cost (Amount)" 
            v-model.number="cost"            
            type="number"
        /> 
        <v-btn color="white" class="ml-2 mt-1" style="color: black;" large @click="itemSelected" >+ ADD</v-btn>
      </div>      
    </div>  
  </template>
  
  <script>
  import {api, srvApi, srvApiNoAuth, PATH, getAssetUrl} from "src/api/index";
  import { costTypeOptions } from "@/core/refdata-utils.js";
  
  export default {
    props: {
      cost_type: {
        type: String,
        required: false,
        default: null
      }
    },
    data() {
      return {        
        optionsList: [...costTypeOptions],        
        selectMode: false,

        selectedCostType: null,
        cost: null,
      }
    },
    computed: {
      header_is_saved() {
        return this.$route && this.$route.fullPath && this.$route.fullPath.endsWith('/create') ? false : true;
        // let ct = this.cost_type;
        // if(ct==null){
        //   return false;
        // }
        // return true;
      }
    },
    watch: {
      cost_type(newVal) {        
        //const rsp = await srvApi.get(PATH.NETWORKOWNER_ASOPTIONS);     
        //this.optionsList.splice(0, this.optionsList.length);
        //this.optionsList.push(...costTypeOptions/*.filter(o=>o.value != newVal)*/);
      }
    },
    methods: {
      initializeSelectMode() {        
        this.selectedCostType=null;        
        this.cost=null;
        this.selectMode=true;
      },
      itemSelected() {
        this.$emit('itemselected', {
            cost_type: this.selectedCostType.value,
            cost: this.cost
        });        
        this.selectMode=false;
      }
    },
    async mounted() {           
      this.optionsList.push(...costTypeOptions/*.filter(o=>o.value != cost_type)*/);
    }
  }
  </script>
  
  <style>
  
  </style>
  